import React from 'react';
import {setParameterToMap} from "actions/index.js";
import {setIsMacroMapping} from 'actions/index.js';
import {connect} from  'react-redux';

const MacroMapButton = ({track, isMacroMapping, setIsMacroMapping, onClick, setParameterToMap, label}) => {
    let className = "macro-map-button";
    if (isMacroMapping) {
        className += " mapping";
    }
    return (
        <div
          onClick={(e) => {
              e.stopPropagation();
              let _mapping = !isMacroMapping;
              setParameterToMap(undefined);
              setIsMacroMapping(_mapping);
              if (onClick) {
                  onClick(_mapping);
              }
          }}
          className={className}>
          {label || "Map"}
        </div>
    );
};


const mapStateToProps = (state, props) => {
    return {
        isMacroMapping: state.effects.isMacroMapping
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
        setIsMacroMapping: (isMapping) => dispatch(
            setIsMacroMapping(isMapping))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroMapButton);
